<template>
  <div class="param-validation">
    <h4 class="text-left mb-3 check-heading">
      <span
        style=""
        :class="{ 'text-danger': errors.length > 0 }"
      >
        <i
          class="material-icons"
          v-if="errors.length === 0"
        >check_circle</i>
        <i
          v-else
          class="material-icons"
        >cancel</i>
      </span>
      Überprüfung der Angebots-Parameter
    </h4>
    <b-row>
      <b-col
        v-for="(item, index) in checked"
        :key="index"
        :md="4"
        class="mb-3"
      >
        <b-card class="condensed-card">
          <div
            class="validation-indicator"
            :class="{
              'text-success': item.success,
              'text-danger': !item.success,
            }"
          >
            <i
              class="material-icons"
              v-if="item.success"
            >check_circle</i>
            <i
              v-else
              class="material-icons"
            >cancel</i>
          </div>
          <b-card-body>
            <b-card-title>
              {{ item.description }}
              <small>{{ formatParamValue(item) }}</small>
            </b-card-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import { get } from 'core-js/core/dict';
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { formatGermanNumber } from '../misc/NumberFormat';
import {
  languageFromCombitFlag,
  offerLanguageLabelFromCombitFlag,
} from '../misc/CombitOfferLanguage';
import { classifyAdditionalCost } from '../misc/CombitTextClassifier';

export default {
  name: 'OfferParams',
  data: function () {
    return {
      loading: false,
      errors: [],
      checked: [],
      offerTypeIds: {
        2: 4,
        3: 1,
        4: 2,
        6: 3,
      },
    };
  },
  computed: {
    ...mapGetters([
      'company',
      'contact',
      'seminar',
      'trainer',
      'employee',
      'offer',
      'offerType',
      'hashParams',
      'hasHashParams',
    ])
  },
  async mounted() {
    let offerParams = {}
    for (const param of this.paramLoaders()) {
      const value = param.getValue();
      this.validateParamValue(param, { value, result: null });
      if (this.hasErrors(param.name)) {
        this.checked = [...this.checked, { ...param, success: false, value }]
        continue;
      }
      if (param.getResult) {
        try {
          await param.getResult(value);
        } catch (err) {
          console.error('Error getting Result for ' + param.name);
          console.error(err);
        }
        this.validateParamResult(param, { value, result: this[param.prop] });
      }
      if (!this.hasErrors(param.name) && param.onSuccess) {
        offerParams[param.name] = param.onSuccess({ value, result: (param.prop) ? this[param.prop] : null })
      }
      this.checked = [...this.checked, { ...param, success: !this.hasErrors(param.name), value }]
    }
    for (const param of this.paramLoaders().filter(p => p.validations && p.validations.checkAfterAll)) {
      for (const validation of param.validations.checkAfterAll) {
        console.log('AfterAll Validation for ' + param.name);
        const value = offerParams[param.name];
        const key = param.name;
        if (!validation.condition({ value, offer: offerParams })) {
          console.log('AfterAll Validation failed for ' + param.name);
          console.log(validation);
          this.errors = [
            ...this.errors,
            {
              name: key,
              message: validation.message({ value, offer: offerParams }),
              value
            }
          ]
        }
      }
      
    }
    this.$emit('loaded', { params: this.hashParams, values: offerParams, errors: this.errors, valid: this.errors.length === 0 })
  },
  methods: {
    ...mapActions([
      'fetchCompany',
      'fetchContact',
      'fetchSeminar',
      'fetchTrainer',
      'fetchEmployee',
      'fetchOfferType',
    ]),
    ...mapMutations([
      'offerSet',
      'clearHashParams',
    ]),
    formatParamValue({ name, value, success }) {
      if (value === null) {
        return "-";
      }
      if (name === "language" && success) {
        return offerLanguageLabelFromCombitFlag(value);
      }
      return name === "duration" ? formatGermanNumber(value) : value;
    },
    validateParamValue(param, value) {
      const validations = (param.validations && param.validations.checkBefore)
        ? param.validations.checkBefore
        : [];
      this.validate(param.name, validations, value);
    },
    validateParamResult(param, result) {
      const validations = (param.validations && param.validations.checkAfter)
        ? param.validations.checkAfter
        : [];
      this.validate(param.name, validations, result);
    },
    validate(name, validations, { value, result }) {
      this.errors = [
        ...this.errors,
        ...validations.reduce((acc, cur) => (acc.length > 0 && acc[acc.length - 1].stopValidationOnError) //if last check was stop item
          ? acc
          : !cur.condition({ value, result })
            ? [...acc, cur]
            : acc
          , [])
          .map(validation => {
            return {
              name,
              message: validation.message({ value, result }),
              value
            }
          })
      ];
    },
    hasErrors(paramName) {
      return this.errors.filter(err => err.name === paramName).length > 0
    },
    errorsByName(paramName) {
      return this.errors.filter(err => err.name === paramName)
    },
    decodeUri(str) {
      //return decodeURIComponent((str+'').replace(/\+/g, '%20'));
      return decodeURIComponent((str + ''));
    },
    mapPriceToInt(pricePosition) {
      return { ...pricePosition, price: parseInt(pricePosition.price) };
    },
    paramLoaders() {
      return [
        {
          name: 'language',
          description: 'Angebotssprache',
          getValue: () => Object.prototype.hasOwnProperty.call(this.hashParams, 'isEnglishOffer')
            ? this.decodeUri(this.hashParams.isEnglishOffer)
            : undefined,
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => {
                  try { languageFromCombitFlag(value); return true; } catch (error) { return false; }
                },
                message: ({ value }) => `isEnglishOffer muss "true" oder "false" sein; übergeben wurde "${value}".`
              },
            ]
          },
          onSuccess: ({ value }) => languageFromCombitFlag(value)
        },
        {
          name: 'company_id',
          description: 'Kunden-ID',
          getValue: () => this.hashParams.companyId ? this.decodeUri(this.hashParams.companyId) : null,
          getResult: (value) => this.fetchCompany(value),
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Keine Firmen-ID übergeben.' },
            ],
            checkAfter: [
              { condition: ({ result }) => result && result.id, message: ({ value }) => `Die Firma mit der ID "${value}" konnte nicht gefunden werden` }
            ]
          },
          prop: 'company',
          onSuccess: ({ result }) => result.id
        },
        {
          name: 'contact_id',
          description: 'Kontakt-ID',
          getValue: () => this.hashParams.contactId ? this.decodeUri(this.hashParams.contactId) : null,
          getResult: (value) => this.fetchContact(this.company.ref_id + '_' + value),
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Keine Kontakt-ID übergeben.' },
              { condition: () => this.company && this.company.ref_id, message: () => 'Ohne zugehörige Firma kann der Kontakt nicht ermittelt werden.' },
            ],
            checkAfter: [
              { condition: ({ result }) => result && result.id, message: ({ value }) => `Kontakt mit der ID "${this.company.ref_id + '_' + value}" konnte nicht gefunden werden.` }
            ]
          },
          prop: 'contact',
          onSuccess: ({ result }) => result.id
        },
        {
          name: 'seminar_id',
          description: 'Seminar-ID',
          getValue: () => this.hashParams.seminarId ? this.decodeUri(this.hashParams.seminarId) : null,
          getResult: (value) => this.fetchSeminar(value),
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Keine Seminar-ID übergeben.' },
              { condition: ({ value }) => !Number.isNaN(parseInt(value)), message: ({ value }) => `Seminar-ID "${value}" ist keine gültige Seminar-Nummer.` }
            ],
            checkAfter: [
              { condition: ({ result }) => result && result.id, message: ({ value }) => `Seminar mit der ID "${value}" konnte nicht gefunden werden.` }
            ]
          },
          prop: 'seminar',
          onSuccess: ({ result }) => result.id
        },
        {
          name: 'trainer_id',
          description: 'Trainer-ID',
          getValue: () => this.hashParams.trainerId ? this.decodeUri(this.hashParams.trainerId) : null,
          getResult: (value) => this.fetchTrainer(value),
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Keine Trainer-ID übergeben.' },
              { condition: ({ value }) => !Number.isNaN(parseInt(value)), message: ({ value }) => `Trainer-ID "${value}" ist muss eine Nummer sein.` }
            ],
            checkAfter: [
              { condition: ({ result }) => result && result.id, message: ({ value }) => `Trainer mit der ID "${value}" konnte nicht gefunden werden.` }
            ]
          },
          prop: 'trainer',
          onSuccess: ({ result }) => result.id
        },
        {
          name: 'employee_id',
          description: 'E-Mail des Erstellers',
          getValue: () => this.hashParams.authorId ? this.decodeUri(this.hashParams.authorId) : null,
          getResult: (value) => this.fetchEmployee(value),
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die E-Mail des Erstellers des Angebots wurde nicht übergeben.' },
              { condition: ({ value }) => typeof value === 'string' && value.match(/.+@gfu\.net/i), message: ({ value }) => `Die übergebene E-Mail des Erstellers "${value}" ist keine gültige GFU-Mailaddresse.` }
            ],
            checkAfter: [
              { condition: ({ result }) => result && result.id, message: ({ value }) => `Mitarbeiter mit der E-Mail "${value}" konnte nicht gefunden werden.` }
            ]
          },
          prop: 'employee',
          onSuccess: ({ result }) => result.id
        },
        {
          name: 'offerType_id',
          description: 'Seminartyp-ID',
          getValue: () => this.hashParams.offerTypeId ? this.decodeUri(this.hashParams.offerTypeId) : null,
          getResult: (value) => this.fetchOfferType(this.offerTypeIds[parseInt(value)]),
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die Angebots-Typ-ID wurde nicht übergeben.' },
              {
                condition: ({ value }) =>
                  !Number.isNaN(parseInt(value)) && //is numerical
                  Object.keys(this.offerTypeIds)    //is in range of offerTypeIds
                    .map(validValue => parseInt(validValue))
                    .includes(parseInt(value)),
                message: ({ value }) => `Die Angebots-Typ-ID "${value}" kann nicht Zugeordnet werden. Gültige Werte sind: "3" für Inhouse, "4" für Firmen und "6" für Kombi`
              },
              {
                condition: ({ value }) => value !== 4,
                message: ({ value }) => `Angebote für "Offene Seminare" können über diesen Weg nicht erstellt werden. Übergeben wurde "${value}" (Offenes Angebot).`
              }
            ],
            checkAfter: [
              { condition: ({ result }) => result && result.id, message: ({ value }) => `Der Angebots-Typ für die ID "${this.offerTypeIds[value]}" konnte nicht gefunden werden.` }
            ]
          },
          prop: 'offerType',
          onSuccess: ({ result }) => result.id
        },
        {
          name: 'seminarDate',
          description: 'Termin',
          getValue: () => this.hashParams.seminarDate ? this.decodeUri(this.hashParams.seminarDate) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Der Termin wurde nicht übergeben.' },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'title',
          description: 'Titel',
          getValue: () => this.hashParams.title ? this.decodeUri(this.hashParams.title) : null,
          validations: {
            checkBefore: [
              { condition: () => true, message: () => 'Der Titel wurde nicht übergeben.' },
            ]
          },
          onSuccess: ({ value }) => value ? value : null
        },
        {
          name: 'numberOfExecutions',
          description: 'Anzahl der Durchführungen',
          getValue: () => this.hashParams.numberOfExecutions ? this.decodeUri(this.hashParams.numberOfExecutions) : 1,
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && !Number.isNaN(parseInt(value)) && parseInt(value) > 0,
                message: () => 'Die Anzahl der Durchführungen muss ein positiver Integerwert sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'duration',
          description: 'Dauer',
          getValue: () => this.hashParams.duration ? this.decodeUri(this.hashParams.duration) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die Dauer des Seminars wurde nicht übergeben.' },
              {
                condition: ({ value }) => value && !Number.isNaN(parseFloat(value)) && parseFloat(value) > 0,
                message: () => 'Die Dauer des Seminars muss ein positiver Floatwert sein.'
              },
            ],
          },
          onSuccess: ({ value }) => parseFloat(value)
        },
        {
          name: 'capacity',
          description: 'Anzahl der Teilnehmer',
          getValue: () => this.hashParams.capacity ? this.decodeUri(this.hashParams.capacity) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die Anzahl der Teilnehmer wurde nicht übergeben.' },
              {
                condition: ({ value }) => value && !Number.isNaN(parseInt(value)) && parseInt(value) > 0,
                message: () => 'Die Anzahl der Teilnehmer muss ein positiver Integerwert sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'isIndividualTraining',
          description: 'Individualschulung',
          getValue: () => this.hashParams.isIndividualTraining ? this.decodeUri(this.hashParams.isIndividualTraining) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false'].includes(value),
                message: () => 'Die Angabe, ob es sich um eine Einzelschulung handelt muss entweder "true" oder "false" sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value === 'true' ? 1 : 0
        },
        {
          name: 'isIndividualAgenda',
          description: 'Individuelles Seminarthema',
          getValue: () => this.hashParams.isIndividualAgenda ? this.decodeUri(this.hashParams.isIndividualAgenda) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false'].includes(value),
                message: () => 'Die Angabe ob es sich um ein Individuelles Seminarthema handelt muss entweder "true" oder "false" sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value === 'true' ? 1 : 0
        },
        {
          name: 'isRemote',
          description: 'Remote-Schulung',
          getValue: () => this.hashParams.isRemote ? this.decodeUri(this.hashParams.isRemote) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false'].includes(value),
                message: () => 'Die Angabe, ob es sich um ein Remoteseminar handelt (isRemote) muss entweder "true" oder "false" sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value === 'true' ? 1 : 0
        },
        {
          name: 'documentsIncluded',
          description: 'Unterlagen inklusive',
          getValue: () => this.hashParams.documentsIncluded ? this.decodeUri(this.hashParams.documentsIncluded) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false'].includes(value),
                message: () => 'Die Angabe, ob die Seminarunterlagen inclusive sind muss entweder "true" oder "false" sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value === 'true' ? 1 : 0
        },
        {
          name: 'location',
          description: 'Veranstatlungsort',
          getValue: () => this.hashParams.location ? this.decodeUri(this.hashParams.location) : null,
          onSuccess: ({ value }) => {
            if (!value || value.trim() === '') {
              if (this.isRemote) {
                value = 'Online';
              } else if (this.seminarType.id === 2 || this.seminarType.id === 4) { //'Firmenschulung' OR 'Offene Schulung'
                value = 'Im Gfu-Schulungszentrum'
              } else if (this.seminarType.id === 3) { //'Kombischulung'
                value = 'Im Gfu-Schulungszentrum oder bei Ihnen in ' + this.company.city
              } else {
                value = 'Bei Ihnen in ' + this.company.city
              }
            }
            return value
          },
        },
        {
          name: 'offerNumber',
          description: 'Angebotsnummer',
          getValue: () => this.hashParams.offerNumber ? this.decodeUri(this.hashParams.offerNumber) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die Angebotsnummer wurde nicht übergeben.' },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'combitId',
          description: 'Combit-ID',
          getValue: () => this.hashParams.offerId ? this.decodeUri(this.hashParams.offerId) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die Angebots-ID (offerId) wurde nicht übergeben.' },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'hash',
          description: 'Angebots-ID',
          getValue: () => this.hashParams.urlHash ? this.decodeUri(this.hashParams.urlHash) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Der URL-Hash wurde nicht übergeben.' },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'vcId',
          description: 'Verkaufschancen-ID',
          getValue: () => this.hashParams.vcId ? this.decodeUri(this.hashParams.vcId) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Die Verkaufchancen-ID wurde nicht übergeben.' },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'ratePerDay',
          description: 'Preis pro Tag',
          getValue: () => this.hashParams.ratePerDay ? this.decodeUri(this.hashParams.ratePerDay) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Der Preis pro Tag wurde nicht übergeben.' },
              {
                condition: ({ value }) => value && !Number.isNaN(parseInt(value)) && parseInt(value) > 0,
                message: () => 'Der Preis pro Tag muss ein positiver Integerwert sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'totalPrice',
          description: 'Gesamtpreis',
          getValue: () => this.hashParams.totalPrice ? this.decodeUri(this.hashParams.totalPrice) : null,
          validations: {
            checkBefore: [
              { condition: ({ value }) => value && value !== '', message: () => 'Der Gesamtpreis des Angebots wurde nicht übergeben.' },
              {
                condition: ({ value }) => value && !Number.isNaN(parseInt(value)) && parseInt(value) > 0,
                message: () => 'Der Gesamtpreis des Angebots muss ein positiver Integerwert sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'startTime',
          description: 'Uhrzeit start',
          getValue: () => (this.hashParams.trainingDayStartTime && this.hashParams.trainingDayStartTime.trim() !== '') ? this.decodeUri(this.hashParams.trainingDayStartTime) : null,
          validations: {
            checkBefore: [
              // {
              //   condition: ({value}) => {
              //     return value !== null
              //   },
              //   message: () => `Die Startzeit wurde nicht übergeben.`
              // },
              {
                condition: ({ value }) => {
                  if (value !== null) {
                    return value.match(/\d{2}\:\d{2}/)
                  } else {
                    return true; //must be true by default because of form v2, correct when switch is done
                  }
                },
                message: ({ value }) => `Die Startzeit "${value}" ist falsch formatiert (HH:MM)`
              },
            ]
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'durationPerDay',
          description: 'Dauer pro Tag',
          getValue: () => (this.hashParams.trainingDayDuration) ? this.decodeUri(this.hashParams.trainingDayDuration) : null,
          validations: {
            checkBefore: [
              // {
              //   condition: ({value}) => {
              //     return value !== null
              //   },
              //   message: () => `Die Seminar-Dauer wurde nicht übergeben.`
              // },
              {
                condition: ({ value }) => {
                  if (value !== null) {
                    return !Number.isNaN(parseFloat(value))
                  } else {
                    return true; //must be true by default because of form v2, correct when switch is done
                  }
                },
                message: ({ value }) => `"${value}" ist keine gültige Seminar-Dauer.`
              }
            ],
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'isClassroom',
          description: 'Präsenz-Schulung',
          getValue: () => this.hashParams.isClassroom ? this.decodeUri(this.hashParams.isClassroom) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false'].includes(value),
                message: () => 'Die Angabe, ob es sich um eine Präsenzschulung handelt (isClassroom) muss entweder "true" oder "false" sein.'
              },
            ]
          },
          onSuccess: ({ value }) => value === 'true' ? 1 : 0
        },
        {
          name: 'travelCostsIncluded',
          description: 'Reisekosten Trainers inkl.',
          getValue: () => this.hashParams.travelCostsIncluded ? this.decodeUri(this.hashParams.travelCostsIncluded) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false', 'Falsch', 'Wahr'].includes(value),
                message: () => 'Die Angabe, ob die kosten des Trainers inklusive sind (travelCostsIncluded) muss entweder "true", "false" oder "Falsch" sein.'
              },
            ]
          },
          onSuccess: ({ value }) => (value === 'true' || value === 'Wahr') ? 1 : 0
        },
        {
          name: 'additionalCostsBase64',
          description: 'Zusätzliche Kosten Base64',
          getValue: () => (this.hashParams.additionalCostsBase64 && this.hashParams.additionalCostsBase64.trim() !== '') ? this.hashParams.additionalCostsBase64 : null,
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => { //if value is a valid base64 string
                  try {
                    window.atob(value);
                    return true;
                  } catch (err) {
                    return false;
                  }
                },
                message: ({ value }) => `Die zusätzlichen kosten sind nicht Base64 kodiert." `,
                stopValidationOnError: true,
              }
            ]
          }
        },
        //numberOfBooksIncluded
        {
          name: 'numberOfBooksIncluded',
          description: 'Bücher inklusive',
          getValue: () => this.hashParams.numberOfBooksIncluded ? this.decodeUri(this.hashParams.numberOfBooksIncluded) : null,
          validations: {
            checkBefore: [],
          },
          onSuccess: ({ value }) => value
        },
        {
          name: 'additionalCosts',
          description: 'Zusätzliche Kosten',
          getValue: () => (this.hashParams.additionalCosts && this.hashParams.additionalCosts.trim() !== '') ? this.hashParams.additionalCosts : "[]",
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => !this.errors.some(({ name }) => { console.log(name); return name === 'additionalCostsBase64' }),
                message: ({ value }) => `Falsche kodierung siehe oben`,
                stopValidationOnError: true,
              },
              {
                condition: ({ value }) => { //if value is a valid json encoded array
                  try {
                    return Array.isArray(JSON.parse(value));
                  } catch (err) {
                    return false;
                  }
                },
                message: ({ value }) => `Die zusätzlichen kosten sind nicht JSON kodiert.`,
                stopValidationOnError: true,
              },
              // {
              //   condition: ({value}) => JSON.parse(value) // check if have price position not integer
              //     .every(({price}) => !(price + '').includes('.')),
              //   message: ({value}) => `Die Preise der zusätzlichen Kosten müssen als ganze Zahlen angegeben werden: ` + JSON.parse(value)
              //       .filter(({price}) => (price + '').includes('.'))
              //       .map(({description, price}) => `Die Position "${description}" hat den ungültigen Preis ${price}.`)
              //       .join(' '),
              //   stopValidationOnError: true,
              // }
            ]
          },
          onSuccess: ({ value }) => JSON.parse(value).map(this.mapPriceToInt),
        },
        {
          name: 'isTravelExpensesAtCost',
          description: 'Reisekosten nachträglich',
          getValue: () => this.hashParams.isTravelExpensesAtCost ? this.decodeUri(this.hashParams.isTravelExpensesAtCost) : 'false',
          validations: {
            checkBefore: [
              {
                condition: ({ value }) => value && ['true', 'false', 'Falsch', 'Wahr'].includes(value),
                message: () => 'Die Angabe, ob die Reisekosten (nachträglich) nach Aufwand abgerechnet werden (isTravelExpensesAtCost) muss entweder "true" oder "false" bzw. "Wahr" oder "Falsch" sein.'
              },
            ],
            checkAfterAll: [
              {
                condition: ({ value, offer }) => {
                  if (value === 1) {
                    //then additional costs must not contain travel costs
                    const additionalCosts = offer.additionalCosts;
                    const hasTravelCosts = additionalCosts.some(
                      cost => {
                        const classification = classifyAdditionalCost(cost.description);
                        return classification && classification.key === 'travelCosts';
                      }
                    );
                    if (hasTravelCosts) {
                      return false;
                    }
                  }
                  return true;
                },
                message: () => 'Wenn die Reisekosten (nachträglich) nach Aufwand abgerechnet werden, dürfen keine Reisekosten im Angebot aufgeführt sein.'
              },
              {
                condition: ({ value, offer }) => {
                  if (value === 1) {
                    //then travelCostsIncluded must be false
                    if(offer.travelCostsIncluded === 1 || offer.travelCostsIncluded === true) {
                      return false;
                    }
                  }
                  return true;
                },
                message: () => 'Wenn die Reisekosten (nachträglich) nach Aufwand abgerechnet werden, dürfen keine Reisekosten im Angebot inklusive sein.'
              }
            ]
          },
          onSuccess: ({ value }) => (value === 'true' || value === 'Wahr' || value === true) ? 1 : 0
        },
      ]
    },
  }
}
</script>

<style>
.list-group-item {
  padding: 0 1.25em;
  background-color: initial;
  border: none
}

.xl-content {
  line-break: anywhere;
}

.condensed-card {
  padding: 10px 15px;
}

.condensed-card .card-title {
  font-size: 1.2em;
  margin-bottom: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 50px);
}

.condensed-card .card-title small {
  font-weight: bold;
  font-size: .8em;
}

.validation-indicator {
  position: absolute;
  right: 10px;
  top: 7.5px;
  font-size: 20px;
}

.check-heading .material-icons,
.debug-heading .material-icons {
  vertical-align: text-top;
  font-size: 1.1em;

}

.debug-link:hover h6 {
  color: #333 !important;
}
</style>
